define('viewModels/privileged/DetailsContainerView',[
    'lib/knockout',
    'lib/lodash4',
    'services/analyticsService',
    'services/routeService',
    'viewModels/ViewModel',
    'viewModels/widgets/MediaTypePickerView',
    'viewModels/SwitchedView',
    'util/codeUtils'
], function (
    ko,
    _,
    analyticsService,
    routeService,
    ViewModel,
    MediaTypePickerView,
    SwitchedView,
    codeUtils
) {
    'use strict';

    // ===============================================================================
    // Class Definition
    // ===============================================================================

    var DetailsContainerView = ViewModel.extend(function () {
        // ===============================================================================
        // Private Variables
        // ===============================================================================

        var self = this;

        var contentViewMappings = ko.observable();
        var contentLinks = ko.observableArray();

        // ===============================================================================
        // Template Data
        // ===============================================================================

        // Used to display a deprecation warning on a view
        self.viewDeprecated = ko.observable(false);
        self.viewDeprecationMessageKey = ko.observable('');

        // The collection of links to display to the end user to allow routing to occur
        self.contentLinks = self.computed(function () {
            return contentLinks();
        });

        // A SwitchedView instance to manage the content sub views
        self.contentSubViews = self.subView(SwitchedView);

        // A collection of mappings for the template's switchedInclude binding.
        self.contentViewMappings = self.computed(function () {
            return contentViewMappings();
        });

        // A string defining the title of the page to display in the breadcrumbs
        self.pageTitle = ko.observable();

        // A string defining the key in the sitemap object to help determine how to update
        // the breadcrumbs on the page
        self.siteMapKey = ko.observable();

        // The MediaTypePickerView will manage the state of the media type to display for
        // the contents of the page.
        self.mediaTypePickerView = self.subView(MediaTypePickerView);

        // A helper method to read the current selected media type.
        self.selectedMediaType = self.computed(function () {
            return self.mediaTypePickerView.selectedMediaTypeValue();
        });

        // Should be an instance of the StatblockView ViewModel
        self.statblockView = ko.observable();

        // ===============================================================================
        // Public Methods
        // ===============================================================================

        /**
         * Set the data that defines the collection of links to display to the user to
         * allow them to traverse between each content subview.
         *
         * [
         *     {
         *         route: "#/route/path",
         *         routeMessageKey: "message.key.label"
         *     }
         * ]
         * @param {Object[]} tabLinks The collection of links to display to the end user
         *  to allow traversal to each subview. Each object entry in the array should have
         *  the following attributes:
         *
         *      {
         *          route: "#/route/path",
         *          routeMessageKey: "message.key.label"
         *      }
         */
        self.setContentLinks = function (tabLinks) {
            contentLinks(ko.unwrap(tabLinks));
        };

        /**
         * Add content views to the container for display to the end user. Each view
         * will be added to the contentSubViews SwitchedView attribute.
         *
         * @param {Object} newContentViews A map of key-value pairs where each key
         *  defines the key name of the view and the object contains references to the
         *  view's constructor and template to load. For Example:
         *
         *      {
         *          "viewName1": {
         *              viewModel: Constructor1,
         *              template: "/path/to/template"
         *          },
         *          "viewName2": {
         *              viewModel: Constructor2,
         *              template: "/path/to/template"
         *          }
         *      }
         */
        self.addContentViews = function (newContentViews) {
            var newContentViewMappings = {};

            _.forIn(ko.unwrap(newContentViews), function (viewData, viewName) {
                self.contentSubViews.addView(viewName, viewData.viewModel);
                newContentViewMappings[viewName] = viewData.template;
            });

            contentViewMappings(newContentViewMappings);
        };

        self.generateClassString = _.partial(codeUtils.generateClassFromString,'nav-link-');

        // ===============================================================================
        // Anonymous Computeds
        // ===============================================================================

        self.computed(function () {
            // Update the breadcrumbs content when the pageTitle observable and/or
            // siteMapKey observables change.
            if (self.pageTitle()) {
                var breadcrumbLabelData = {};
                breadcrumbLabelData[self.siteMapKey()] = {
                    pageTitle: self.pageTitle()
                };
                var breadcrumbData = routeService.breadcrumbsNavData() || {};
                breadcrumbData = _.merge(breadcrumbData, {
                    labelData: breadcrumbLabelData
                });
                routeService.breadcrumbsNavData(breadcrumbData);
            }
        });

        self.computed(function () {
            // Manage the media type selected for the current active content view.
            // This will respond to any changes made to the active view or current selected
            // media type.
            var activeContentView = ko.unwrap(self.contentSubViews[self.contentSubViews.getActiveView()]);

            if (activeContentView && _.has(activeContentView, "mediaType")) {
                activeContentView.mediaType(self.mediaTypePickerView.selectedMediaTypeValue());
            }
        });
    });

    return DetailsContainerView;
});

